export enum ProductionOrderStatuses {
  Created = 'Angelegt',
  Filled = 'Abgefüllt',
  MhdChecked = 'MHD geprüft',
  Labeled = 'Etikettiert',
  Posted = 'Eingebucht',
  Canceled = 'Abgebrochen'
}
